import { type ReactNode } from "react";
import { IconeBusca } from "../icons";
import { CampoTexto, type CampoTextoProps } from "./CampoTexto";
import styles from "./CampoPesquisa.module.css";

interface CampoPesquisaProps extends Omit<CampoTextoProps, "rotulo"> {
  iconeInicio?: ReactNode;
}

export function CampoPesquisa({
  className,
  inputClassName,
  iconeInicio,
  placeholder = "Pesquisar...",
  ignorarProgresso = true,
  ...rest
}: CampoPesquisaProps) {
  const iconeResolvido = iconeInicio === undefined ? <IconeBusca /> : iconeInicio;

  return (
    <CampoTexto
      {...rest}
      className={[styles.campo, "cad-search-field", className].filter(Boolean).join(" ")}
      inputClassName={[styles.input, inputClassName].filter(Boolean).join(" ")}
      iconeInicio={iconeResolvido}
      placeholder={placeholder}
      ignorarProgresso={ignorarProgresso}
    />
  );
}
